import i18next from 'i18next';
import axios from 'axios';
import { BASE_URL, USER } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { USER_MESSAGE_TYPES } from '../../UserMessageFlow/constants';
import { getFromLocalStorage } from '../../../services/storage.service';
import { handleDownload } from '../../../services/general.service';

const {
  CONTROLLERS: {
    GET_DIRECT_DEPOSIT_FORM: { BASE, VERSION },
  },
} = USER;
const { currUser } = useStore.getState();
const { setMessageObject } = useStore.getState();
const { getPersonalAccountId } = useStore.getState();
const { t } = i18next;

const authUserIdInLocalStorage = getFromLocalStorage('authUserId');

const getExtendedParam = () => {
  const param = currUser()?.authorizedUserId || authUserIdInLocalStorage;
  if (param) {
    return `?authorizedUserId=${param}`;
  }
  return '';
};

export const sendBankLetterService = async () => {
  try {
    setMessageObject({
      type: USER_MESSAGE_TYPES.UPPER_MESSAGE,
      messageText: '',
      processingText: `${t('DIRECT_DEPOSIT_PAGE_POPUP_TEXT_2')}`,
      needSpinner: true,
    });
    const url = `${BASE_URL}/api/${VERSION}/user/${currUser().customerId}/${getPersonalAccountId()}/${BASE}${getExtendedParam()}`;
    const { data } = await axios(url, {
      responseType: 'blob',
      method: 'GET',
    });
    handleDownload(URL.createObjectURL(data), 'BankLetter.pdf');
    setMessageObject({ type: USER_MESSAGE_TYPES.ZERO_STATE });
  } catch (e) {
    console.error(e);
    setMessageObject({ type: USER_MESSAGE_TYPES.ZERO_STATE });
  }
};
